import { catalogSchema, episodeSchema, type Catalog, type Episode } from '@tales/story-schema';

export const CONTENT_BASE = '/content';

async function getJson(url: string): Promise<unknown> {
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) throw new Error(`${res.status} ${url}`);
  return res.json();
}

export async function loadCatalog(): Promise<Catalog> {
  return catalogSchema.parse(await getJson(`${CONTENT_BASE}/catalog.json`));
}

export async function loadEpisode(seriesId: string, episodeId: string): Promise<Episode> {
  return episodeSchema.parse(await getJson(`${CONTENT_BASE}/${seriesId}/${episodeId}/episode.json`));
}

/** Absolute URL of a media file declared relative to the episode folder. */
export function mediaUrl(seriesId: string, episodeId: string, rel: string | undefined): string | undefined {
  return rel ? `${CONTENT_BASE}/${seriesId}/${episodeId}/${rel}` : undefined;
}

export function holdFrameUrl(seriesId: string, episodeId: string, nodeId: string): string {
  return `${CONTENT_BASE}/${seriesId}/${episodeId}/media/${nodeId}.hold.jpg`;
}
